export default "__VITE_ASSET__3e7311da__"